export const PAGINATION_GOPAGE = 'PAGINATION_GOPAGE';
